import { render } from "./MainScreen.vue?vue&type=template&id=5eda01b0&scoped=true"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"

import "./MainScreen.vue?vue&type=style&index=0&id=5eda01b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eda01b0"]])

export default __exports__